import {useEffect, useState} from "react";
import iconEdit2 from "@iconify/icons-eva/edit-2-outline";
import {useNavigate, useSearchParams} from "react-router-dom";
import {QRCODE_TYPE_LABELS, QRCODE_TYPES} from "src/config/constants";
import plusFill from "@iconify/icons-eva/plus-fill";
import {Icon} from "@iconify/react";
// material
import {
  Card,
  Table,
  Button,
  Stack,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TextField,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
// components
import Page from "src/components/Page";
import Scrollbar from "src/components/Scrollbar";
import SearchNotFound from "src/components/SearchNotFound";
import MoreMenu from "src/components/common/MoreMenu";
import ListHead from "src/components/common/ListHead";
import ListToolbar from "src/components/common/ListToolbar";
import {alert} from "src/services/alert";
import MyPagination from "src/components/common/MyPagination";
import {asyncRequest} from "src/services/network";
import LookCodeDialog from "src/components/dialogs/lookCodeDialog";
import LookMerchantParentDialog from "../merchant/components/lookMerchantParentDialog";

const TABLE_HEAD = [
  {id: "cid", label: "码牌ID", alignRight: false},
  {id: "qrcodeUrl", label: "码牌地址", alignRight: false},
  {id: "merchantInfo", label: "商户信息", alignRight: false},
  {id: "codeType", label: "二维码类型", alignRight: false},
  {id: "action", label: "操作", align: "center"},
];

const moreMenus = [
  {title: "收款码", icon: iconEdit2},
  {title: "绑定超级管理员", icon: iconEdit2},
  {title: "修改推荐人", icon: iconEdit2},
  {title: "绑定区代", icon: iconEdit2},
];

export default function MerchantList() {
  const navigate = useNavigate();
  const [selected, setSelected] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();

  const [targetMerchant, setTargetMerchant] = useState({});

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [action, setAction] = useState("");
  const [openHF, setOpenHF] = useState("");
  const [openKF, setOpenKF] = useState("");
  const [wxAuthData, setWxAuthData] = useState({});
  const [agentMap, setAgentMap] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const roleLevels = Object.values(QRCODE_TYPES);
  const [filter, setFilter] = useState({
    page: 0,
    size: 10,
    // search: "",
    sort: null,
    order: null,
    mid: "",
    name: "",
    provinceId: null,
    cityId: null,
    districtId: searchParams.get("districtId") || "",
    version: null,
    createdAt: null,
    platformCode: 'huifu',
    codeType:''
  });

  const [form, setForm] = useState({
    userType: "0",
    userName: 0,
    phone: "",
    certId: "",
    cardNo: "",
    certIdExpires: "",
    bankCode: "",
    cardName: "",
    codeType:''
  });

  useEffect(() => {
    getItems();
  }, [filter]);

  useEffect(() => {
    // getAgentMap();

  }, [items]);

  async function getItems() {
    const {data, count} = await asyncRequest({
      path: "/qrcode/list",
      data: filter,
    });
    setItems(data);
    setTotal(count);
    if (targetMerchant.mid) {
      const item = data.find((d) => d.mid == targetMerchant.mid);
      if (item) {
        setTargetMerchant(item);
      }
    }
  }

  const handlePageChange = (event, value, newSize) => {
    if (newSize !== undefined) {
      setFilter({ ...filter, page: 0, size: newSize });
      return;
    }
    const newPage = value - 1;
    if (newPage === filter.page) return;
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  function handleSizeChange(value) {
    setFilter({
      ...filter,
      size: value,
    });
  }

  const handleFilterByName = (event) => {
    setFilter({
      ...filter,
      search: event.target.value,
    });
  };

  const onRefreshClick = async () => {
    await getItems()
  };

  const handleMoreClick = (type, row) => {
    if (type === "绑定商户") {
      setTargetMerchant(row)
      setAction("bindParent")
    }
  };

  function handleFilterChange(ki, val) {
    setFilter({
      ...filter,
      [ki]: val,
      page: 0,
    });
  }
  function handleReset() {
    setFilter({
      page: 0,
      size: 10,
      // search: "",
      sort: null,
      order: null,
      mid: "",
      name: "",
      provinceId: null,
      cityId: null,
      districtId: searchParams.get("districtId") || "",
      version: null,
      createdAt: null,
      platformCode: 'huifu',
      codeType:''
    });
  }
  function lookClicK(row) {
    setTargetMerchant(row)
    setAction("payCode")
  }
  async function qrcodeAdd() {
    const {msg} = await asyncRequest({
      path: "/qrcode/create",
      data: {
        size: 10
      },
    });
    alert(msg, "success");
    getItems()
  }

  async function handleExport() {
    const {msg} = await asyncRequest({
      path: "/merchant/export",
      data: filter,
    });
    alert(msg, "success");
  }

  const isUserNotFound = items.length === 0;

  return (
    <>
      <Page title="商户码牌列表">
        <Container maxWidth="2000px">
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            <Typography variant="h4" gutterBottom>
              商户码牌列表
            </Typography>
            <Button
              variant="contained"
              to="add"
              startIcon={<Icon icon={plusFill}/>}
              onClick={() => {
                qrcodeAdd();
              }}
            >
              添加码牌
            </Button>
          </Stack>
          <Card>
            {/* <ListToolbar filterName={filter.search} onFilterName={handleFilterByName} onRefresh={getItems}
                         onExport={handleExport} onReset={handleReset}> */}
                <ListToolbar filterName={filter.search} onFilterName={handleFilterByName} onRefresh={getItems}
                         onReset={handleReset}>
              <Grid container>
                <Grid item md={3}>
                  <TextField
                    label="商户ID"
                    size="small"
                    placeholder="商户ID"
                    autoComplete="off"
                    id="mid"
                    value={filter.mid}
                    onChange={(e) => {
                      handleFilterChange("mid", e.target.value);
                    }}
                  />
                </Grid>
                <Grid item md={3}>
                  <TextField
                    size="small"
                    label="商户名称"
                    placeholder="商户名称"
                    autoComplete="off"
                    id="name"
                    value={filter.name}
                    onChange={(e) => {
                      handleFilterChange("name", e.target.value);
                    }}
                  />
                </Grid>
                <Grid item sm={6} md={3}>
                  <FormControl size="small">
                    <InputLabel>二维码类型</InputLabel>
                    <Select
                      label="二维码类型"
                      value={filter.codeType}
                      onChange={(e) => {
                        setFilter({
                          ...filter,
                          codeType: e.target.value,
                        });
                      }}
                      style={{width: 250}}
                    >
                      {[null, ...roleLevels].map((roleLevel, idx) => (
                        <MenuItem key={idx} value={roleLevel} name={roleLevel}>
                          {idx == 0 ? "全部" : QRCODE_TYPE_LABELS[roleLevel]}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </ListToolbar>
            <Scrollbar>
              <TableContainer sx={{minWidth: 800}}>
                <Table stickyHeader>
                  <ListHead headLabel={TABLE_HEAD} orderBy={filter.sort} order={filter.order}/>
                  <TableBody>
                    {items.map((row) => {
                      const {
                        cid,
                        qrcodeUrl,
                        merchant,
                        codeType,
                      } = row;
                      return (
                        <TableRow hover key={cid} tabIndex={-1} role="checkbox">
                          <TableCell align="left">
                              <Stack>
                                <Typography noWrap>
                                  {cid?cid: ''}
                                </Typography>
                              </Stack>
                          </TableCell>
                          <TableCell align="left">
                            <Stack>
                              <Typography>
                                {qrcodeUrl}
                              </Typography>
                              <Typography>
                                <Button
                                  size="small"
                                  variant="outlined"
                                  onClick={() => {
                                    lookClicK(row);
                                  }}
                                >
                                  码牌二维码查看
                                </Button>
                            </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell align="left">
                              <Stack>
                                <Typography noWrap>
                                  ID：
                                  {merchant&&merchant.mid?merchant.mid: ''}
                                </Typography>
                                <Typography noWrap>
                                  名称：
                                  {merchant?.name || ''}
                                </Typography>
                              </Stack>
                          </TableCell>
                          <TableCell>
                            <Stack>
                              <Typography>
                                {QRCODE_TYPE_LABELS[codeType] || codeType || ''}
                            </Typography>
                            </Stack>
                          </TableCell>
                          {/* <TableCell align="center">
                            <Stack direction="row"
                                   spacing={1}
                                   alignItems="center"
                                   justifyContent="flex-end"
                                   sx={{minWidth: 120}}>
                              <Button
                                size="small"
                                variant="outlined"
                                onClick={() =>
                                  handleMoreClick('新增制作记录', row)}>
                                修改记录
                              </Button>
                            </Stack>
                          </TableCell> */}
                          <TableCell align="right">
                            <Stack direction="row"
                              spacing={1}
                              alignItems="center"
                              // justifyContent="flex-end"
                              sx={{ minWidth: 120 }}>
                              <Button
                                size="small"
                                variant="outlined"
                                onClick={() =>
                                handleMoreClick('绑定商户', row)}>
                                {merchant&&merchant.mid?'更新商户':'绑定商户'}
                              </Button>
                              {/* <MoreMenu spread={false} menus={moreMenus}
                                        onMoreClick={(type) => handleMoreClick(type, row)}/> */}
                            </Stack>
                          </TableCell>
                        </TableRow>
                      )
                        ;
                    })}
                  </TableBody>
                  {isUserNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{py: 5}}>
                          <SearchNotFound searchQuery={filter.search}/>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>
            <MyPagination total={total} page={filter.page} size={filter.size} onChange={handlePageChange}
                          onSizeChange={handleSizeChange}/>
          </Card>
          {action === "payCode" && (
          <LookCodeDialog
            open={true}
            merchant={targetMerchant}
            onClose={() => {
              setAction("");
              setTargetMerchant({});
            }}
          />
        )}
        {action == "bindParent" && (
          <LookMerchantParentDialog
            open
            merchant={targetMerchant}
            onFinish={() => {
              getItems();
              setAction("");
            }}
            onClose={() => setAction("")}
          />
        )}
        </Container>
      </Page>
    </>
  );
}
